import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DesignIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.9521 16.8926H3.92617C3.68054 16.8926 3.44496 16.795 3.27127 16.6214C3.09758 16.4477 3 16.212 3 15.9664V3.92617C3 3.68054 3.09758 3.44496 3.27127 3.27127C3.44496 3.09758 3.68054 3 3.92617 3H15.9664C16.212 3 16.4477 3.09758 16.6214 3.27127C16.795 3.44496 16.8926 3.68054 16.8926 3.92617V10.9521C16.8925 11.1976 16.795 11.433 16.6215 11.6066L11.6066 16.6215C11.433 16.795 11.1976 16.8925 10.9521 16.8926Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.3362 16.8124V12.2649C11.3362 12.0193 11.4337 11.7837 11.6074 11.61C11.7811 11.4363 12.0167 11.3387 12.2624 11.3387H16.8099",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.70483 6.70087H14.1142",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.70483 9.48566H9.94644",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
